import Character from "../Character";
import { CharacterAction } from "../CharacterAction";
import CharacterBehavior from "./CharacterBehavior";

export default class CharacterBrain {
    /**
     * @param {string} id The brain id
     * @param {Array.<CharacterBehavior>} behaviors 
     */
    constructor(id, behaviors) {

        /**
         * @constant
         * @type {string}
         */
        this.id = id;

        /**
         * @constant
         * @type {Array.<CharacterBehavior>}
         */
        this.behaviors = behaviors;
    }

    // /**
    //  * 
    //  * @param {Character} character 
    //  * @returns {boolean}
    //  */
    // isValidForTurnChoice(character) {
    //     if (character.position.isCenteredOnTile()) {
    //         return true;
    //     }

    //     // We are still carrying out a turn. Do not choose a new one.
    //     if (character.turnAction && character.turnAction.isMovementAction() && character.position.pathPlan.length > 0) {
    //         return;
    //     }
    // }

    /**
     * @param {Character} character
     */
    chooseTurn(character) {

        // Note: We do not want to choose a turn if we are in motion and halfway between tiles.
        // Only apply the turn if we are centered.
        // 1. centered
        // 2. no path plan, or between path steps.  cannot be mid step.
        // if we are not centered and we do not have a turnAction, then something is wrong and we should reset position.

        if (!character.position.isCenteredOnTile()) {
            // We are still carrying out a turn. Do not choose a new one.
            if (character.turnAction && character.turnAction.isMovementAction() && character.position.pathPlan.length > 0) {
                return;
            }
            else if (character.position.gravityThisFrame === 0) {
                // We're in an invalid state. We cannot be off-centered if we have no path plan, and we are not falling
                console.log('CharacterBrain.chooseTurn() not centered on tile and have no path plan. partyMember=' + character.isPartyMember() + ' monster=' + character.isMonster());
                character.resetTurnState(); // <-- this centers the character too
            }
        }

        // Initialize the turn action
        character.turnAction = null;

        const tile = character.position.tile;
        if (!tile) {
            character.resetTurnState();
            return;
        }

        const grid = tile.grid;
        if (!grid.isLoaded()) {
            console.log('CharacterBarin.chooseTurn() character in grid that is not loaded.');
            character.resetTurnState();
            return;
        }

        // No turn if we are falling.
        if (character.position.gravityThisFrame > 0) {
            return;
        }

        // Apply the behaviors
        this.applyBehaviors(character, this.behaviors);

        // If we have no action for this turn, make sure we clear out the path.
        if (!character.turnAction) {
            character.position.resetPathPlan();

            character.setCharacterAction(CharacterAction.STAND);
        }
    }

    /**
     * @param {Character} character
     * @param {CharacterBehavior[]} behaviors
     */
    applyBehaviors(character, behaviors) {
        // sub-classes can override this.
        let behaviorApplied = false;
        for (let i = 0; i < behaviors.length; i++) {
            if (behaviors[i].applyIfAppropriate(character)) {
                behaviorApplied = true;

                ///////////////////////////////////////
                //  if (character.isPartyMember()) {
                //      character.target.behaviorName = behaviors[i].getName();
                //  }
                ///////////////////////////////////////

                break;
            }
        }

        // If no behavior claims the target, then clear the target.
        if (!behaviorApplied) {
            character.target.resetTarget();
        }
    }
}